import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-keyvisual-slider', observe: true })
export class KeyvisualSliderComponent {
	private swiper: Swiper;

	constructor(public element: HTMLElement) {
		this.swiper = new Swiper(this.element, {
			speed: 600,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				bulletActiveClass: 'is-active'
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			}
		});
	}
}
